import { DataStreamVisualisation } from '../../types/Visualisation';
import { DataStreamLineGraphConfig } from './Config';
import LineGraph from './visComponents/LineGraph';

const DataStreamLineGraph: DataStreamVisualisation<DataStreamLineGraphConfig> = (props) => {
    return <LineGraph {...props} />;
};

DataStreamLineGraph.config = 'DataStreamLineGraphConfig';

export default DataStreamLineGraph;
